export class FilterDataItem {
  public property: string;
  public value: string;

  constructor(property: string, value: string) {
    this.property = property;
    this.value = value;
  }
}
